import type { ReactElement, ReactNode } from 'react'

import { useAppChrome } from '@/components/layout/app-chrome'
import { AppHeader } from '@/components/layout/AppHeader'

interface PageHeaderProps {
  title: string
  onBack?: (() => void) | undefined
  searchPlaceholder?: string | undefined
  /** Point the search field at the Explore panel instead of a page search. */
  searchOpensExplore?: boolean
  actions?: ReactNode
  /** Shows the help (?) button next to the avatar and runs this when clicked. */
  onHelp?: (() => void) | undefined
  /** Accessible label of the help button. */
  helpLabel?: string | undefined
  nodeId?: string
  onSearchChange?: ((value: string) => void) | undefined
}

/**
 * The shared `header` wired to the shell. Every routed page renders one — the
 * Figma frames give Discover, News and Event each a different second row, so
 * the header belongs to the page rather than to the shell.
 */
export function PageHeader({
  title,
  onBack,
  searchPlaceholder,
  searchOpensExplore = false,
  actions,
  onHelp,
  helpLabel,
  nodeId,
  onSearchChange,
}: PageHeaderProps): ReactElement {
  const { openMenu, openUserPanel, openExplore, unreadCount } = useAppChrome()

  return (
    <AppHeader
      title={title}
      onOpenMenu={openMenu}
      onOpenUserPanel={openUserPanel}
      unreadCount={unreadCount}
      onBack={onBack}
      searchPlaceholder={searchPlaceholder}
      {...(searchOpensExplore ? { onSearchClick: openExplore } : {})}
      actions={actions}
      onHelp={onHelp}
      helpLabel={helpLabel}
      onSearchChange={onSearchChange}
      {...(nodeId ? { nodeId } : {})}
    />
  )
}
